"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleServiceScopeCreator = void 0;
const LocaleService_1 = require("./LocaleService");
class LocaleServiceScopeCreator {
    /**
     * Retrieves an empty copy of the original LocaleService for usage on server-side.
     */
    static fromScratch() {
        return Object.create(LocaleService_1.LocaleService).reset();
    }
    /**
     * Retrieves an initialized copy of the original LocaleService for usage on server-side.
     */
    static fromParams(params) {
        const localServiceScope = LocaleServiceScopeCreator.fromScratch();
        localServiceScope.init(params);
        return localServiceScope;
    }
}
exports.LocaleServiceScopeCreator = LocaleServiceScopeCreator;
//# sourceMappingURL=LocaleServiceScopeCreator.js.map